<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">Location List</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
                <json-excel
                  class="btn btn-success"
                  style="float: right;"
                  :data="itemList"
                  :fields="exportFields"
                  name="location-list.xls"
                  >
                  Export
                </json-excel>
              <h4>
                <i class="fa fa-list-ul"></i>
                Site/Location List
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <div class="row">
          </div>
          <hr/>
          
            <div class="co-md-12">
                <div class="section">
                    <b-table id="item-table"
                      :fields="fields"
                      hover
                      :items="itemList" 
                      :per-page="perPage"
                      :current-page="currentPage">
                      <!-- A virtual column -->
                      <template #cell(sno)="data">
                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                      </template>
                    </b-table>
                  <!-- Show pagination links -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      aria-controls="item-table"
                      hide-ellipsis
                      ></b-pagination>
                </div>
            </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import { BTable, BPagination } from 'bootstrap-vue'
import JsonExcel from "vue-json-excel";

export default {
  name: "LocationList",

  components: {
    BPagination,
    BTable,
    JsonExcel
  },
  data() {
    return {
      itemList: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'site_name', label: 'Site Name'},
        { key:'project_name', label: 'Project Name'},
        { key:'site_address', label: 'Site Location'},
        { key:'site_mobile', label: 'Mobile'},
        { key:'site_engineer', label: 'Site Enigneer'},
        { key:'site_supervisor', label: 'Site Suprevisor'}
        ],
      exportFields: {
        'Location Name': 'site_name',
        'Project': 'project_name',
        'Address': 'site_address',
        'Mobile': 'site_mobile',
        'Site Engineer': 'site_engineer',
        'Site Supervisor': 'site_supervisor'
      }
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_sites", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.siteList;
            this.totalRows = this.itemList.length
          }
        });
    }
  },
  mounted(){
    this.getList()
  }
};
</script>
